import * as React from 'react';
import { FixMeLater } from '../../utils';
import { Styler, StylerBaseProps } from '../Styler';
import { STATIC_STYLES, useDynamicStyles } from './Scrollbar.styles';

export interface ScrollbarsProps extends StylerBaseProps {
    /**
     * The width of the draggable scrollbar handle.
     * @default 5
     */
    scrollbarHandleWidth?: string | number;

    /**
     * The padding surrounding the scrollbar handle.
     * @default 3
     */
    scrollbarPadding?: string | number;

    /**
     * Margin which will be applied at either end of the scrollbar track.
     * @default 0
     */
    scrollbarEndMargin?: string | number;

    /**
     * If `true`, scrolling will be disabled.
     * @default false
     */
    disabled?: boolean;
}

/**
 * Scrollbars is an extended Styler component which applies mimimally styled scrollbars.
 */
export const Scrollbars: React.ForwardRefExoticComponent<ScrollbarsProps & React.RefAttributes<HTMLElement>> =
    React.forwardRef(function Scrollbars(
        props: ScrollbarsProps,
        ref: React.ForwardedRef<FixMeLater>
    ): React.JSX.Element {
        const {
            scrollbarHandleWidth = 5,
            scrollbarPadding = 3,
            scrollbarEndMargin = 0,
            disabled = false,
            ...other
        } = props;

        const cssVariables = useDynamicStyles(scrollbarHandleWidth, scrollbarPadding, scrollbarEndMargin);

        return (
            <Styler
                ref={ref}
                style={cssVariables}
                baseStyles={STATIC_STYLES}
                overflowY={disabled ? 'hidden' : 'auto'}
                {...other}
            />
        );
    });
